import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host {
  display: inline-flex;
}

:host([data-on-hover]:not([disabled], [readonly])) atlas-icon {
  color: #ffffff;
}

.atlas-phone-flag {
  width: 20px;
  height: 15px;
  background-repeat: no-repeat;
  background-color: #dbdbdb;
  background-position: 20px 0;
}

.flag-ac {
  height: 10px;
  background-position: 0 0;
}

.flag-ad {
  height: 14px;
  background-position: -22px 0;
}

.flag-ae {
  height: 10px;
  background-position: -44px 0;
}

.flag-af {
  height: 14px;
  background-position: -66px 0;
}

.flag-ag {
  height: 14px;
  background-position: -88px 0;
}

.flag-ai {
  height: 10px;
  background-position: -110px 0;
}

.flag-al {
  height: 15px;
  background-position: -132px 0;
}

.flag-am {
  height: 10px;
  background-position: -154px 0;
}

.flag-ao {
  height: 14px;
  background-position: -176px 0;
}

.flag-aq {
  height: 14px;
  background-position: -198px 0;
}

.flag-ar {
  height: 13px;
  background-position: -220px 0;
}

.flag-as {
  height: 10px;
  background-position: -242px 0;
}

.flag-at {
  height: 14px;
  background-position: -264px 0;
}

.flag-au {
  height: 10px;
  background-position: -286px 0;
}

.flag-aw {
  height: 14px;
  background-position: -308px 0;
}

.flag-ax {
  height: 13px;
  background-position: -330px 0;
}

.flag-az {
  height: 10px;
  background-position: -352px 0;
}

.flag-ba {
  height: 10px;
  background-position: -374px 0;
}

.flag-bb {
  height: 14px;
  background-position: -396px 0;
}

.flag-bd {
  height: 12px;
  background-position: -418px 0;
}

.flag-be {
  width: 18px;
  height: 15px;
  background-position: -440px 0;
}

.flag-bf {
  height: 14px;
  background-position: -460px 0;
}

.flag-bg {
  height: 12px;
  background-position: -482px 0;
}

.flag-bh {
  height: 12px;
  background-position: -504px 0;
}

.flag-bi {
  height: 12px;
  background-position: -526px 0;
}

.flag-bj {
  height: 14px;
  background-position: -548px 0;
}

.flag-bl {
  height: 14px;
  background-position: -570px 0;
}

.flag-bm {
  height: 10px;
  background-position: -592px 0;
}

.flag-bn {
  height: 10px;
  background-position: -614px 0;
}

.flag-bo {
  height: 14px;
  background-position: -636px 0;
}

.flag-bq {
  height: 14px;
  background-position: -658px 0;
}

.flag-br {
  height: 14px;
  background-position: -680px 0;
}

.flag-bs {
  height: 10px;
  background-position: -702px 0;
}

.flag-bt {
  height: 14px;
  background-position: -724px 0;
}

.flag-bv {
  height: 15px;
  background-position: -746px 0;
}

.flag-bw {
  height: 14px;
  background-position: -768px 0;
}

.flag-by {
  height: 10px;
  background-position: -790px 0;
}

.flag-bz {
  height: 14px;
  background-position: -812px 0;
}

.flag-ca {
  height: 10px;
  background-position: -834px 0;
}

.flag-cc {
  height: 10px;
  background-position: -856px 0;
}

.flag-cd {
  height: 15px;
  background-position: -878px 0;
}

.flag-cf {
  height: 14px;
  background-position: -900px 0;
}

.flag-cg {
  height: 14px;
  background-position: -922px 0;
}

.flag-ch {
  width: 15px;
  height: 15px;
  background-position: -944px 0;
}

.flag-ci {
  height: 14px;
  background-position: -961px 0;
}

.flag-ck {
  height: 10px;
  background-position: -983px 0;
}

.flag-cl {
  height: 14px;
  background-position: -1005px 0;
}

.flag-cm {
  height: 14px;
  background-position: -1027px 0;
}

.flag-cn {
  height: 14px;
  background-position: -1049px 0;
}

.flag-co {
  height: 14px;
  background-position: -1071px 0;
}

.flag-cp {
  height: 14px;
  background-position: -1093px 0;
}

.flag-cr {
  height: 12px;
  background-position: -1115px 0;
}

.flag-cu {
  height: 10px;
  background-position: -1137px 0;
}

.flag-cv {
  height: 12px;
  background-position: -1159px 0;
}

.flag-cw {
  height: 14px;
  background-position: -1181px 0;
}

.flag-cx {
  height: 10px;
  background-position: -1203px 0;
}

.flag-cy {
  height: 14px;
  background-position: -1225px 0;
}

.flag-cz {
  height: 14px;
  background-position: -1247px 0;
}

.flag-de {
  height: 12px;
  background-position: -1269px 0;
}

.flag-dg {
  height: 10px;
  background-position: -1291px 0;
}

.flag-dj {
  height: 14px;
  background-position: -1313px 0;
}

.flag-dk {
  height: 15px;
  background-position: -1335px 0;
}

.flag-dm {
  height: 10px;
  background-position: -1357px 0;
}

.flag-do {
  height: 14px;
  background-position: -1379px 0;
}

.flag-dz {
  height: 14px;
  background-position: -1401px 0;
}

.flag-ea {
  height: 14px;
  background-position: -1423px 0;
}

.flag-ec {
  height: 14px;
  background-position: -1445px 0;
}

.flag-ee {
  height: 13px;
  background-position: -1467px 0;
}

.flag-eg {
  height: 14px;
  background-position: -1489px 0;
}

.flag-eh {
  height: 10px;
  background-position: -1511px 0;
}

.flag-er {
  height: 10px;
  background-position: -1533px 0;
}

.flag-es {
  height: 14px;
  background-position: -1555px 0;
}

.flag-et {
  height: 10px;
  background-position: -1577px 0;
}

.flag-eu {
  height: 14px;
  background-position: -1599px 0;
}

.flag-fi {
  height: 12px;
  background-position: -1621px 0;
}

.flag-fj {
  height: 10px;
  background-position: -1643px 0;
}

.flag-fk {
  height: 10px;
  background-position: -1665px 0;
}

.flag-fm {
  height: 11px;
  background-position: -1687px 0;
}

.flag-fo {
  height: 15px;
  background-position: -1709px 0;
}

.flag-fr {
  height: 14px;
  background-position: -1731px 0;
}

.flag-ga {
  height: 15px;
  background-position: -1753px 0;
}

.flag-gb {
  height: 10px;
  background-position: -1775px 0;
}

.flag-gd {
  height: 12px;
  background-position: -1797px 0;
}

.flag-ge {
  height: 14px;
  background-position: -1819px 0;
}

.flag-gf {
  height: 14px;
  background-position: -1841px 0;
}

.flag-gg {
  height: 14px;
  background-position: -1863px 0;
}

.flag-gh {
  height: 14px;
  background-position: -1885px 0;
}

.flag-gi {
  height: 10px;
  background-position: -1907px 0;
}

.flag-gl {
  height: 14px;
  background-position: -1929px 0;
}

.flag-gm {
  height: 14px;
  background-position: -1951px 0;
}

.flag-gn {
  height: 14px;
  background-position: -1973px 0;
}

.flag-gp {
  height: 14px;
  background-position: -1995px 0;
}

.flag-gq {
  height: 14px;
  background-position: -2017px 0;
}

.flag-gr {
  height: 14px;
  background-position: -2039px 0;
}

.flag-gs {
  height: 10px;
  background-position: -2061px 0;
}

.flag-gt {
  height: 13px;
  background-position: -2083px 0;
}

.flag-gu {
  height: 11px;
  background-position: -2105px 0;
}

.flag-gw {
  height: 10px;
  background-position: -2127px 0;
}

.flag-gy {
  height: 12px;
  background-position: -2149px 0;
}

.flag-hk {
  height: 14px;
  background-position: -2171px 0;
}

.flag-hm {
  height: 10px;
  background-position: -2193px 0;
}

.flag-hn {
  height: 10px;
  background-position: -2215px 0;
}

.flag-hr {
  height: 10px;
  background-position: -2237px 0;
}

.flag-ht {
  height: 12px;
  background-position: -2259px 0;
}

.flag-hu {
  height: 10px;
  background-position: -2281px 0;
}

.flag-ic {
  height: 14px;
  background-position: -2303px 0;
}

.flag-id {
  height: 14px;
  background-position: -2325px 0;
}

.flag-ie {
  height: 10px;
  background-position: -2347px 0;
}

.flag-il {
  height: 15px;
  background-position: -2369px 0;
}

.flag-im {
  height: 10px;
  background-position: -2391px 0;
}

.flag-in {
  height: 14px;
  background-position: -2413px 0;
}

.flag-io {
  height: 10px;
  background-position: -2435px 0;
}

.flag-iq {
  height: 14px;
  background-position: -2457px 0;
}

.flag-ir {
  height: 12px;
  background-position: -2479px 0;
}

.flag-is {
  height: 15px;
  background-position: -2501px 0;
}

.flag-it {
  height: 14px;
  background-position: -2523px 0;
}

.flag-je {
  height: 12px;
  background-position: -2545px 0;
}

.flag-jm {
  height: 10px;
  background-position: -2567px 0;
}

.flag-jo {
  height: 10px;
  background-position: -2589px 0;
}

.flag-jp {
  height: 14px;
  background-position: -2611px 0;
}

.flag-ke {
  height: 14px;
  background-position: -2633px 0;
}

.flag-kg {
  height: 12px;
  background-position: -2655px 0;
}

.flag-kh {
  height: 13px;
  background-position: -2677px 0;
}

.flag-ki {
  height: 10px;
  background-position: -2699px 0;
}

.flag-km {
  height: 12px;
  background-position: -2721px 0;
}

.flag-kn {
  height: 14px;
  background-position: -2743px 0;
}

.flag-kp {
  height: 10px;
  background-position: -2765px 0;
}

.flag-kr {
  height: 14px;
  background-position: -2787px 0;
}

.flag-kw {
  height: 10px;
  background-position: -2809px 0;
}

.flag-ky {
  height: 10px;
  background-position: -2831px 0;
}

.flag-kz {
  height: 10px;
  background-position: -2853px 0;
}

.flag-la {
  height: 14px;
  background-position: -2875px 0;
}

.flag-lb {
  height: 14px;
  background-position: -2897px 0;
}

.flag-lc {
  height: 10px;
  background-position: -2919px 0;
}

.flag-li {
  height: 12px;
  background-position: -2941px 0;
}

.flag-lk {
  height: 10px;
  background-position: -2963px 0;
}

.flag-lr {
  height: 11px;
  background-position: -2985px 0;
}

.flag-ls {
  height: 14px;
  background-position: -3007px 0;
}

.flag-lt {
  height: 12px;
  background-position: -3029px 0;
}

.flag-lu {
  height: 12px;
  background-position: -3051px 0;
}

.flag-lv {
  height: 10px;
  background-position: -3073px 0;
}

.flag-ly {
  height: 10px;
  background-position: -3095px 0;
}

.flag-ma {
  height: 14px;
  background-position: -3117px 0;
}

.flag-mc {
  width: 19px;
  height: 15px;
  background-position: -3139px 0;
}

.flag-md {
  height: 10px;
  background-position: -3160px 0;
}

.flag-me {
  height: 10px;
  background-position: -3182px 0;
}

.flag-mf {
  height: 14px;
  background-position: -3204px 0;
}

.flag-mg {
  height: 14px;
  background-position: -3226px 0;
}

.flag-mh {
  height: 11px;
  background-position: -3248px 0;
}

.flag-mk {
  height: 10px;
  background-position: -3270px 0;
}

.flag-ml {
  height: 14px;
  background-position: -3292px 0;
}

.flag-mm {
  height: 14px;
  background-position: -3314px 0;
}

.flag-mn {
  height: 10px;
  background-position: -3336px 0;
}

.flag-mo {
  height: 14px;
  background-position: -3358px 0;
}

.flag-mp {
  height: 10px;
  background-position: -3380px 0;
}

.flag-mq {
  height: 14px;
  background-position: -3402px 0;
}

.flag-mr {
  height: 14px;
  background-position: -3424px 0;
}

.flag-ms {
  height: 10px;
  background-position: -3446px 0;
}

.flag-mt {
  height: 14px;
  background-position: -3468px 0;
}

.flag-mu {
  height: 14px;
  background-position: -3490px 0;
}

.flag-mv {
  height: 14px;
  background-position: -3512px 0;
}

.flag-mw {
  height: 14px;
  background-position: -3534px 0;
}

.flag-mx {
  height: 12px;
  background-position: -3556px 0;
}

.flag-my {
  height: 10px;
  background-position: -3578px 0;
}

.flag-mz {
  height: 14px;
  background-position: -3600px 0;
}

.flag-na {
  height: 14px;
  background-position: -3622px 0;
}

.flag-nc {
  height: 10px;
  background-position: -3644px 0;
}

.flag-ne {
  width: 18px;
  height: 15px;
  background-position: -3666px 0;
}

.flag-nf {
  height: 10px;
  background-position: -3686px 0;
}

.flag-ng {
  height: 10px;
  background-position: -3708px 0;
}

.flag-ni {
  height: 12px;
  background-position: -3730px 0;
}

.flag-nl {
  height: 14px;
  background-position: -3752px 0;
}

.flag-no {
  height: 15px;
  background-position: -3774px 0;
}

.flag-np {
  width: 13px;
  height: 15px;
  background-position: -3796px 0;
  background-color: transparent;
}

.flag-nr {
  height: 10px;
  background-position: -3811px 0;
}

.flag-nu {
  height: 10px;
  background-position: -3833px 0;
}

.flag-nz {
  height: 10px;
  background-position: -3855px 0;
}

.flag-om {
  height: 10px;
  background-position: -3877px 0;
}

.flag-pa {
  height: 14px;
  background-position: -3899px 0;
}

.flag-pe {
  height: 14px;
  background-position: -3921px 0;
}

.flag-pf {
  height: 14px;
  background-position: -3943px 0;
}

.flag-pg {
  height: 15px;
  background-position: -3965px 0;
}

.flag-ph {
  height: 10px;
  background-position: -3987px 0;
}

.flag-pk {
  height: 14px;
  background-position: -4009px 0;
}

.flag-pl {
  height: 13px;
  background-position: -4031px 0;
}

.flag-pm {
  height: 14px;
  background-position: -4053px 0;
}

.flag-pn {
  height: 10px;
  background-position: -4075px 0;
}

.flag-pr {
  height: 14px;
  background-position: -4097px 0;
}

.flag-ps {
  height: 10px;
  background-position: -4119px 0;
}

.flag-pt {
  height: 14px;
  background-position: -4141px 0;
}

.flag-pw {
  height: 13px;
  background-position: -4163px 0;
}

.flag-py {
  height: 11px;
  background-position: -4185px 0;
}

.flag-qa {
  height: 8px;
  background-position: -4207px 0;
}

.flag-re {
  height: 14px;
  background-position: -4229px 0;
}

.flag-ro {
  height: 14px;
  background-position: -4251px 0;
}

.flag-rs {
  height: 14px;
  background-position: -4273px 0;
}

.flag-ru {
  height: 14px;
  background-position: -4295px 0;
}

.flag-rw {
  height: 14px;
  background-position: -4317px 0;
}

.flag-sa {
  height: 14px;
  background-position: -4339px 0;
}

.flag-sb {
  height: 10px;
  background-position: -4361px 0;
}

.flag-sc {
  height: 10px;
  background-position: -4383px 0;
}

.flag-sd {
  height: 10px;
  background-position: -4405px 0;
}

.flag-se {
  height: 13px;
  background-position: -4427px 0;
}

.flag-sg {
  height: 14px;
  background-position: -4449px 0;
}

.flag-sh {
  height: 10px;
  background-position: -4471px 0;
}

.flag-si {
  height: 10px;
  background-position: -4493px 0;
}

.flag-sj {
  height: 15px;
  background-position: -4515px 0;
}

.flag-sk {
  height: 14px;
  background-position: -4537px 0;
}

.flag-sl {
  height: 14px;
  background-position: -4559px 0;
}

.flag-sm {
  height: 15px;
  background-position: -4581px 0;
}

.flag-sn {
  height: 14px;
  background-position: -4603px 0;
}

.flag-so {
  height: 14px;
  background-position: -4625px 0;
}

.flag-sr {
  height: 14px;
  background-position: -4647px 0;
}

.flag-ss {
  height: 10px;
  background-position: -4669px 0;
}

.flag-st {
  height: 10px;
  background-position: -4691px 0;
}

.flag-sv {
  height: 12px;
  background-position: -4713px 0;
}

.flag-sx {
  height: 14px;
  background-position: -4735px 0;
}

.flag-sy {
  height: 14px;
  background-position: -4757px 0;
}

.flag-sz {
  height: 14px;
  background-position: -4779px 0;
}

.flag-ta {
  height: 10px;
  background-position: -4801px 0;
}

.flag-tc {
  height: 10px;
  background-position: -4823px 0;
}

.flag-td {
  height: 14px;
  background-position: -4845px 0;
}

.flag-tf {
  height: 14px;
  background-position: -4867px 0;
}

.flag-tg {
  height: 13px;
  background-position: -4889px 0;
}

.flag-th {
  height: 14px;
  background-position: -4911px 0;
}

.flag-tj {
  height: 10px;
  background-position: -4933px 0;
}

.flag-tk {
  height: 10px;
  background-position: -4955px 0;
}

.flag-tl {
  height: 10px;
  background-position: -4977px 0;
}

.flag-tm {
  height: 14px;
  background-position: -4999px 0;
}

.flag-tn {
  height: 14px;
  background-position: -5021px 0;
}

.flag-to {
  height: 10px;
  background-position: -5043px 0;
}

.flag-tr {
  height: 14px;
  background-position: -5065px 0;
}

.flag-tt {
  height: 12px;
  background-position: -5087px 0;
}

.flag-tv {
  height: 10px;
  background-position: -5109px 0;
}

.flag-tw {
  height: 14px;
  background-position: -5131px 0;
}

.flag-tz {
  height: 14px;
  background-position: -5153px 0;
}

.flag-ua {
  height: 14px;
  background-position: -5175px 0;
}

.flag-ug {
  height: 14px;
  background-position: -5197px 0;
}

.flag-um {
  height: 11px;
  background-position: -5219px 0;
}

.flag-un {
  height: 14px;
  background-position: -5241px 0;
}

.flag-us {
  height: 11px;
  background-position: -5263px 0;
}

.flag-uy {
  height: 14px;
  background-position: -5285px 0;
}

.flag-uz {
  height: 10px;
  background-position: -5307px 0;
}

.flag-va {
  width: 15px;
  height: 15px;
  background-position: -5329px 0;
}

.flag-vc {
  height: 14px;
  background-position: -5346px 0;
}

.flag-ve {
  height: 14px;
  background-position: -5368px 0;
}

.flag-vg {
  height: 10px;
  background-position: -5390px 0;
}

.flag-vi {
  height: 14px;
  background-position: -5412px 0;
}

.flag-vn {
  height: 14px;
  background-position: -5434px 0;
}

.flag-vu {
  height: 12px;
  background-position: -5456px 0;
}

.flag-wf {
  height: 14px;
  background-position: -5478px 0;
}

.flag-ws {
  height: 10px;
  background-position: -5500px 0;
}

.flag-xk {
  height: 15px;
  background-position: -5522px 0;
}

.flag-ye {
  height: 14px;
  background-position: -5544px 0;
}

.flag-yt {
  height: 14px;
  background-position: -5566px 0;
}

.flag-za {
  height: 14px;
  background-position: -5588px 0;
}

.flag-zm {
  height: 14px;
  background-position: -5610px 0;
}

.flag-zw {
  height: 10px;
  background-position: -5632px 0;
}

@media (min-resolution: 2), (min-resolution: 192dpi) {
  .flag {
    background-image: url("../../../assets/images/flags@2x.png");
    background-size: 5652px 15px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
